import React, { useState } from 'react';

import CasinoCRMApi from '../../../../casino/Api/CRM/CasinoCRMApi';
import CasinoGameSessions from '../../../../casino/Api/Models/CasinoGameSessions';
import DownloadButton from '../../../elements/DownloadButton';
import { PERMISSION } from '../../../helpers/Permissions';
import useAutoPaginator, { FetchPaginatorParams } from '../../../hooks/useAutoPaginator';

import SessionsTable from './SessionsTable';

function TransactionsList() {
    const [queryParams, setQueryParams] = useState<FetchPaginatorParams>();
    const { items, isLoading, auto } = useAutoPaginator<CasinoGameSessions>((page, params) => {
        setQueryParams(params);
        return CasinoCRMApi.transactions.getPaginatedSessions(page, { params });
    });

    return (
        <>
            <DownloadButton
                action="bets-as-csv"
                title="Export to CSV"
                permissions={[PERMISSION.DOWNLOAD_BETS]}
                defaultFilename="bets.csv"
                params={queryParams}
            />
            <SessionsTable
                sessions={items}
                isLoading={isLoading}
                sortProps={auto.sort}
                autoSearch={auto.search}
                autoFilter={auto.filter}
                autoPaginator={auto.paginator}
            />
        </>
    );
}

export default TransactionsList;
